import Box from '@mui/material/Box'
import Chip from '@mui/material/Chip'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import SearchIcon from '@mui/icons-material/Search'
import styled from 'styled-components'

export const Header = styled(Box)`
  height: 64px;
  flex-shrink: 0;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(15, 23, 42, 0.12);
  background-color: #ffffff;
  gap: 16px;
`

export const Title = styled(Typography)`
  && {
    font-size: 1.25rem;
    font-weight: 600;
    line-height: 1.2;
  }
`

export const Subtitle = styled(Typography)`
  && {
    font-size: 0.75rem;
    color: #64748b;
  }
`

export const ImpersonationChip = styled(Chip)`
  && {
    font-weight: 600;
  }
`

export const EndSessionText = styled(Typography)`
  && {
    font-size: 11px;
    padding: 0 4px;
    cursor: pointer;
  }
`

export const RightSide = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
`

export const SearchField = styled(TextField)`
  width: 220px;

  & .MuiOutlinedInput-root {
    border-radius: 8px;
  }
`

export const SearchAdornmentIcon = styled(SearchIcon)`
  && {
    color: #94a3b8;
  }
`
